import Vue from "vue";

const state = Vue.observable({
  alerts: {
    devicesOffline: 0,
    apisDown: 0,
    serversDown: 0,
    highDisk: 0,
  },
});

export function setMonitorAlerts(partialAlerts) {
  state.alerts = {
    ...state.alerts,
    ...partialAlerts,
  };
}

export function getMonitorAlerts() {
  return state.alerts;
}
